import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'actassa-detail-list',
    templateUrl: './detail-list.component.html',
    styleUrls: ['./detail-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailListComponent { }
